var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAspectRatioInstaLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 54,
    viewBox: "0 0 43 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 42,
    height: 53,
    fill: "#121212",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAspectRatioInstaLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aspect-ratio-insta-light.5db35421569a946a55a43113246ef749.svg";